import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from "antd";
import VehicleTypePickerModal from "./VehicleTypePickerModal";
import VehicleTypeCategoryImg from "./VehicleTypeCategoryImg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
const VehicleTypeImgPicker = ({ vehicleType, tenantId, performsCustomerDeliveries, marketplaceParticipator, salesOrderApplicableTenantId, editable = true, onChange, errorMessage, }) => {
    const [vehicleTypeImgPickerModalVisible, setVehicleTypeImgPickerModalVisible] = React.useState(false);
    const showVehicleTypeImgPickerModal = () => {
        setVehicleTypeImgPickerModalVisible(true);
    };
    const hideVehicleTypeImgPickerModal = () => {
        setVehicleTypeImgPickerModalVisible(false);
    };
    const onVehicleTypeSelected = (vehicleType) => {
        hideVehicleTypeImgPickerModal();
        onChange && onChange(vehicleType);
    };
    return (_jsxs("div", { children: [_jsx("h2", { children: vehicleType ? vehicleType.description : "Vehicle Type" }), _jsxs("div", { className: "pb-2", children: [vehicleType
                        ? _jsx(VehicleTypeCategoryImg, { category: vehicleType.category.name, size: 'lg' })
                        : _jsxs("span", { className: "text-light", children: [_jsx(FontAwesomeIcon, { icon: faTruck, size: "2x" }), " No Selection"] }), "\u00A0\u00A0\u00A0", editable &&
                        _jsx(Button, { htmlType: "button", onClick: showVehicleTypeImgPickerModal, type: "default", children: vehicleType ? "Change" : "Select" })] }), errorMessage &&
                _jsx("p", { className: "error-text", children: errorMessage }), editable && tenantId &&
                _jsx(VehicleTypePickerModal, { open: vehicleTypeImgPickerModalVisible, tenantId: tenantId, performsCustomerDeliveries: performsCustomerDeliveries, marketplaceParticipator: marketplaceParticipator, salesOrderApplicableTenantId: salesOrderApplicableTenantId, onSelect: onVehicleTypeSelected, onCancel: hideVehicleTypeImgPickerModal })] }));
};
export default VehicleTypeImgPicker;
